import { render, staticRenderFns } from "./TestDetails.vue?vue&type=template&id=f823e8e8&"
import script from "./TestDetails.vue?vue&type=script&lang=js&"
export * from "./TestDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports